import { staticMediaUrl } from '@/fo/util/image-loader';

import { styles } from './Technology.styles';

export function Technology() {
  const slots = styles();

  return (
    <div
      className={slots.base()}
      id="technology"
    >
      <div className={slots.row()}>
        <div className={slots.column()}>
          <video
            className={slots.video()}
            src={staticMediaUrl(
              'landing/ie_intensive_nad/technology-video.mp4'
            )}
            width={720}
            height={720}
            autoPlay
            muted
            playsInline
            loop
          />
        </div>
        <div className={slots.column()}>
          <div className={slots.content()}>
            <h2 className={slots.title()}>
              ЗАПАТЕНТОВАННАЯ ФОРМУЛА
              <br />
              <span className={slots.bold()}>
                [УСИЛИТЕЛЬ НАД+<sup>1</sup> И&nbsp;НИАЦИНАМИД]
              </span>
            </h2>
            <p className={slots.text()}>
              Первая формула{' '}
              <span className={slots.semibold()}>
                с усилителем НАД+ и&nbsp;ниацинамидом
              </span>
              , повышающая уровень НАД+ в&nbsp;коже и&nbsp;усиливающая
              эффективность ниацинамида для заметного улучшения общего состояния
              кожи.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
